import { useUserStore } from "@/stores/user";
import router from "@/router";
import { useUiStore } from "@/stores/ui";
import { Auth, canEnterAfterTmaAuth } from "@/api/auth";

export const initAuth = async () => {
  let isTry = false;
  const tryAuth = async () => {
    isTry = true;

    const { hidePreloader, setDataLoaded } = useUiStore();
    const authReq = await Auth.tmaAuth();

    if (authReq.isError) {
      setDataLoaded(true);
      hidePreloader();
    }

    return authReq;
  };
  router.beforeEach(async (to) => {
    const userStore = useUserStore();
    const uiStore = useUiStore();

    if (!userStore.isAuth && !isTry) {
      const authReq = await tryAuth();

      // Холодный старт / рефреш (Ctrl+F5) уводим на Dashboard при успешной авторизации
      // ИЛИ demo-режиме (TG_AUTH_FAIL → authNeedEmail). Исключение — public-роуты
      // (2FA, error) и сам Dashboard (без петли). Deep-link по start_param не ломается:
      // форвард живёт в Dashboard.onMounted.
      // Прочие ошибки tmaAuth → экран Error с повторной авторизацией, иначе
      // пользователь застревает на Loading (isTry уже true, ретрая не будет).
      if (!to.meta.public) {
        if (!canEnterAfterTmaAuth(authReq)) return { name: "Error" };
        if (to.name !== "Dashboard") return { name: "Dashboard" };
      }
    }

    if (!userStore.isAuth && !to.meta.public) {
      uiStore.hidePreloader();
    }
  });
};
